<template>
    <div>
        <v-col cols="12" sm="12" md="12">
            <h6>{{ title }}</h6>
            <v-radio-group
                v-model="radioGroupSelectedValue"
                :value="radioData"
                :rules="[(v) => !!v || t('default::validation.field.required')]"
                required
                column
            >
                <v-radio
                    v-for="(item, index) in radioData"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                    color="primary"
                ></v-radio>
            </v-radio-group>
            <v-select
                v-if="isCustomValue"
                v-model="internalValue"
                :items="customValues"
                item-text="label"
                item-value="value"
                dense
                chips
                small-chips
                outlined
                clearable
                :placeholder="t(selectPlaceholder)"
            ></v-select>
        </v-col>
    </div>
</template>
<script>
export default {
    name: 'RadioGroupMinutes',
    props: {
        title: {
            type: String,
            required: true,
        },
        radioData: {
            type: Array,
            required: true,
        },
        selectPlaceholder: {
            type: String,
            required: true,
        },
        customValues: {
            type: Array,
            required: true,
        },
        selected: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            lazySelected: this.selected,
        };
    },
    computed: {
        internalValue: {
            get() {
                return this.lazySelected === 'undefined' || this.lazySelected === 'custom' ? '0' : this.lazySelected;
            },
            set(v) {
                this.lazySelected = v.toString();
                this.$emit('input', v.toString());
            },
        },
        isCustomValue() {
            return this.selected === 'custom' || _.find(this.radioData, { value: this.selected }) === undefined;
        },
        radioGroupSelectedValue: {
            get() {
                if (_.find(this.radioData, { value: this.selected })) {
                    return this.selected;
                }
                return 'custom';
            },
            set(v) {
                this.internalValue = v;
            },
        },
    },
    watch: {
        selected(newValue) {
            this.internalValue = newValue === 'custom' ? '0' : newValue;
            this.lazySelected = newValue;
        },
    },
};
</script>
